import React, { useState } from "react";
import "../../_css/help.css";
import Training from "./Training";
import Scanner from "./Scanner";

const Index = () => {
  const [selectedTog, setselectedTog] = useState("training");
  return (
    <div className="help-main">
      <div className="class-toggle-con" style={{ width: "fit-content" }}>
        <div
          onClick={() => setselectedTog("training")}
          className="class-toggle pe-cursor"
          style={{
            color: selectedTog == "training" && "#030712",
            backgroundColor: selectedTog == "training" && "#FFFFFF",
          }}
        >
          Instructions
        </div>
        <div
          onClick={() => setselectedTog("scanner")}
          className="class-toggle pe-cursor"
          style={{
            color: selectedTog == "scanner" && "#030712",
            backgroundColor: selectedTog == "scanner" && "#FFFFFF",
          }}
        >
          {" "}
          Scanner{" "}
        </div>
      </div>

      {selectedTog === "training" && <Training />}
      {selectedTog === "scanner" && <Scanner />}
    </div>
  );
};

export default Index;
